import React, {
    createContext,
    useContext,
    useState,
    useEffect,
    ReactNode,
} from "react";
import { createPortal } from "react-dom";

import { useAuth } from "../AuthContext";

import style from "../style/components/Header.module.css";
let count = 0;
const Header = () => {
    const { user } = useAuth();
    const [log, setLog] = useState<boolean>(false);

    const refresh = () => {
        count++;
        if (count > 5) {
            window.location.href = `${
                window.location.pathname
            }?t=${Date.now()}`;
        }
    };

    return (
        <div className={style["container"]}>
            <div onClick={refresh}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="28"
                    viewBox="0 0 21 28"
                    fill="#999999"
                >
                    <path d="M7.92067 0V12.9333C8.98796 11.8167 9.96463 11.03 10.8507 10.57C11.7367 10.11 12.6597 9.87667 13.6162 9.87667C14.8345 9.87667 15.8783 10.22 16.7442 10.91C17.6101 11.6 18.1841 12.4067 18.4693 13.3367C18.7546 14.2667 18.8956 15.8333 18.8956 18.0333V23.8067C18.8956 25.28 19.0332 26.2 19.3118 26.5633C19.5903 26.9267 20.1508 27.16 20.9966 27.2567V28H11.1427V27.2567C11.8341 27.16 12.3543 26.8867 12.7033 26.43C12.9517 26.0733 13.0759 25.1967 13.0759 23.8067V16.96C13.0759 15.3633 13.0121 14.3633 12.8879 13.9567C12.7335 13.45 12.4415 13.0833 12.0186 12.8567C11.7703 12.7233 11.4951 12.6633 11.2131 12.6667C10.6694 12.6733 10.1425 12.8633 9.62565 13.2333C9.5216 13.31 9.4142 13.3967 9.30345 13.4933C8.40062 14.3133 7.92067 15.5 7.92067 16.7167V23.8067C7.92067 25.1833 8.02472 26.0433 8.23281 26.3867C8.49459 26.8533 9.03495 27.1433 9.85387 27.2533V27.9967H-5.40984e-05V27.2533C0.818869 27.17 1.3995 26.91 1.74519 26.47C1.98013 26.1667 2.0976 25.28 2.0976 23.8067V4.19333C2.0976 2.73333 1.96335 1.82667 1.69149 1.46667C1.41964 1.11 0.855787 0.873333 -0.00341034 0.763333V0H7.91732H7.92067Z" />
                    <path d="M15.8146 1.1C16.6604 1.1 17.3753 1.39333 17.9626 1.98333C18.5466 2.57 18.8419 3.28 18.8419 4.10667C18.8419 4.93333 18.5466 5.63667 17.9525 6.22C17.3618 6.8 16.647 7.09333 15.8146 7.09333C14.9823 7.09333 14.2741 6.80333 13.6867 6.22C13.1028 5.64 12.8074 4.93333 12.8074 4.10667C12.8074 3.28 13.0994 2.57333 13.6867 1.98333C14.2707 1.39667 14.9823 1.1 15.8146 1.1Z" />
                </svg>
            </div>
            {log && user?.displayName == "테스트" && (
                <LogDisplay close={() => setLog(false)} />
            )}
        </div>
    );
};

export const LogDisplay = ({
    close,
    content,
}: {
    close: () => void;
    content?: string;
}) => {
    const [logOutput, setLogOutput] = useState<string>("");

    useEffect(() => {
        const originalConsoleLog = console.log;
        console.log = (...args: any[]) => {
            setLogOutput(
                (prevLogOutput) => `${prevLogOutput}\n${args.join(" ")}`
            );
            originalConsoleLog(...args);
        };

        return () => {
            console.log = originalConsoleLog;
        };
    }, []);

    return createPortal(
        <div className={style["container--log"]}>
            <p>
                {logOutput}
                {content ? `content: ${content}` : ""}
            </p>
            <button
                onClick={() => {
                    window.location.href = `${
                        window.location.pathname
                    }?t=${Date.now()}`;
                }}
            >
                새로고침
            </button>
            <button onClick={() => setLogOutput("")}>로그 지우기</button>
            <button onClick={close}>로그창 종료</button>
        </div>,
        document.body
    );
};

export default Header;
